import type { IdName } from "./IdName";
import type { ChannelOfferDiscountAudienceCountry, OfferAudience } from "./offer";

export enum ChannelCategory {
    EatIn = "eatIn",
    TakeAway = "takeAway",
    Delivery = "delivery",
    TakeAwayDelivery = "takeaway-delivery",
}

export enum ChannelSourceEnum {
    Deliveroo = "deliveroo",
    Ubereats = "ubereats",
    Glovo = "glovo",
    JustEat = "just-eat",
    Web = "web",
    App = "app",
    Other = "other",
    Pos = "pos",
}

export enum ChannelMode {
    ON_SITE = "on-site",
    TAKEAWAY = "takeAway",
    DELIVERY = "delivery",
    TAKEAWAY_DELIVERY = "takeaway-delivery",
    OTHER = "other",
}
export interface Channel extends IdName {
    id: number;
    name: string;
    category: ChannelCategory;
    channelOfferDiscountAudienceCountries?: ChannelOfferDiscountAudienceCountry[];
    offerAudiences?: OfferAudience[];
    services?: ("deliveroo" | "ubereats")[];
    orderOfImportance?: number;
    posIds?: number[];
    source: ChannelSourceEnum;
}
